export const PLATFORM = {
    Web: 'Web',
    Mobile: 'Mobile',
    iOS: 'iOS',
    Android: 'Android',
    Huawei: 'Huawei',
    Unknown: 'Unknown',
} as const;
export type Platform = typeof PLATFORM[keyof typeof PLATFORM];
export type PlatformLower = Lowercase<Platform>;

export const SOURCE = { web: 'web', app: 'app' } as const;
export type Source = typeof SOURCE[keyof typeof SOURCE];

const resolvePlatformFromConfig = (): Platform => {
    const val = String((window as any)?.config?.platformType);
    switch (val) {
        case '1':
            return PLATFORM.Web;
        case '2':
            return PLATFORM.Mobile;
        case '3':
            return PLATFORM.iOS;
        case '4':
            return PLATFORM.Android;
        case '5':
            return PLATFORM.Huawei;
        default:
            return PLATFORM.Unknown;
    }
};

export type GetPlatformOptions = {
    // If true, returns lowercase variant (e.g., 'web'); otherwise TitleCase (e.g., 'Web')
    lowerCase?: boolean;
    // If true (default), Unknown will be returned as Web (or 'web' when lowerCase=true)
    // Set to false to keep Unknown (used by LiveAgent case)
    defaultWeb?: boolean;
};

export function getPlatformFromConfig(options?: GetPlatformOptions): Platform | PlatformLower {
    const res = resolvePlatformFromConfig();
    const defaultWeb = options?.defaultWeb ?? true;
    const effective = res === PLATFORM.Unknown && defaultWeb ? PLATFORM.Web : res;
    return options?.lowerCase ? (effective.toLowerCase() as PlatformLower) : effective;
}


